import { AnalyticsBrowser } from '@segment/analytics-next'
import { SEGMENTS_WRITE_KEY } from '../../config/env.config';

export const analytics = new AnalyticsBrowser.load({ writeKey: SEGMENTS_WRITE_KEY})